export default "__VITE_ASSET__CSgiFbeA__"